import { Link, useOutletContext } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, useSeo } from "@/components/site/Motion";
import { site } from "@/content/site";

export default function JournalHome() {
  const { journal } = useOutletContext();
  useSeo(journal.title, journal.excerpt);
  return (
    <div className="space-y-16" data-testid="journal-home">
      <Reveal>
        <p className="eyebrow mb-5">About the Journal</p>
        <div className="prose-mp text-lg max-w-3xl">
          {journal.about.map((p, i) => <p key={i} className={i === 0 ? "font-display !text-3xl !leading-snug !text-[var(--ink)]" : ""}>{p}</p>)}
        </div>
        <Link to={`/index.php/${journal.slug}/about`} className="inline-flex items-center gap-2 mt-2 text-[var(--emerald)] font-medium link-u" data-testid="journal-read-more">Read more about the journal <ArrowUpRight className="w-4 h-4" /></Link>
      </Reveal>

      {journal.welcome && (
        <Reveal className="border border-[var(--line)] bg-white p-8 lg:p-12" data-testid="journal-welcome-block">
          <p className="eyebrow mb-4">Welcome to {site.name}</p>
          <h2 className="font-display text-4xl sm:text-5xl leading-[1.05] mb-6">{site.tagline}</h2>
          <p className="text-[var(--ink-muted)] text-lg leading-relaxed mb-8">{site.intro}</p>
          <h3 className="font-mono-x text-xs tracking-[0.2em] uppercase text-[var(--ink-muted)] mb-4">Our Journals</h3>
          <ul className="divide-y divide-[var(--line)] border-y border-[var(--line)] mb-6">
            {site.ourJournals.map((j, i) => (
              <li key={j.name} className="py-4 flex items-baseline gap-5"><span className="font-mono-x text-sm text-[var(--terracotta)]">0{i + 1}</span><span className="font-display text-2xl">{j.name}</span></li>
            ))}
          </ul>
          <p className="text-[var(--ink-muted)]">{site.explore}</p>
        </Reveal>
      )}

      <Reveal className="grid sm:grid-cols-2 gap-5">
        <Link to={`/index.php/${journal.slug}/issue/current`} className="group border border-[var(--line)] p-8 hover:bg-[var(--emerald)] hover:text-[var(--paper)] transition-colors" data-testid="journal-home-current">
          <p className="font-mono-x text-xs tracking-[0.2em] uppercase opacity-80 mb-8">Current issue</p>
          <p className="font-display text-3xl flex justify-between">Read the latest <ArrowUpRight className="w-6 h-6 group-hover:rotate-45 transition-transform" /></p>
        </Link>
        <Link to={`/index.php/${journal.slug}/issue/archive`} className="group border border-[var(--line)] p-8 hover:bg-[var(--ink)] hover:text-[var(--paper)] transition-colors" data-testid="journal-home-archive">
          <p className="font-mono-x text-xs tracking-[0.2em] uppercase opacity-80 mb-8">Archives</p>
          <p className="font-display text-3xl flex justify-between">Browse all issues <ArrowUpRight className="w-6 h-6 group-hover:rotate-45 transition-transform" /></p>
        </Link>
      </Reveal>
    </div>
  );
}
